
































































import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import HelpBubble from "@/components/HelpBubble.vue";

@Component({
  components: {HelpBubble}
})
export default class Footer extends BasicComponent {

}

